import React from 'react';

interface ProcessingViewProps {
  fileName?: string;
  message: string;
  currentPage?: number;
  totalPages?: number;
}

const ProcessingView: React.FC<ProcessingViewProps> = ({
  fileName,
  message,
  currentPage,
  totalPages,
}) => {
  const showPageProgress = typeof currentPage === 'number' && typeof totalPages === 'number' && totalPages > 0;
  const pageProgressPercent = showPageProgress ? (currentPage / totalPages) * 100 : 0;

  return (
    <div className="w-full text-center p-8 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700">
      <div className="flex flex-col items-center justify-center">
        <div className="w-16 h-16 border-4 border-green-500 border-dashed rounded-full animate-spin border-t-transparent mb-6"></div>
        <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">Preparing Document</h2>
        {fileName && (
          <p className="text-slate-500 dark:text-slate-400 mt-2 font-mono truncate max-w-full px-4">
            {fileName}
          </p>
        )}
        <p className="text-green-600 dark:text-green-400 mt-4 text-lg">{message}</p>
        {showPageProgress && (
          <div className="w-full max-w-md mt-6">
            <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">
              Page {currentPage} of {totalPages}
            </p>
            <div className="h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
              <div
                className="h-full bg-green-500 transition-all duration-300 ease-out"
                style={{ width: `${pageProgressPercent}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProcessingView;
